import { Typography } from '@workspace/ui/components/Typography';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useGlobal } from '~/hooks/useGlobal';

import styles from './DeliveryAddressRestriction.module.scss';

const DeliveryAddressRestriction: FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();

  return (
    <div
      className={isMobile ? styles.containerMobile : styles.container}
      role="alert"
    >
      <Typography.Text300Semibold className={styles.title}>
        {t('checkout:deliveryAddressRestrictionTitle')}
      </Typography.Text300Semibold>
      <Typography.Text200Regular className={styles.description}>
        {t('checkout:addNewAddressSubtitle')}
      </Typography.Text200Regular>
    </div>
  );
};

export default DeliveryAddressRestriction;
